/**
 * External File Search Agent - Intro Section
 * Section 1: Intro, Overview, Goals
 *
 * Keywords AI Key: EXTERNAL_FILE_SEARCH_INTRO
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { EXTERNAL_FILE_SEARCH_PROMPT_KEYS } from './variables';
class ExternalFileSearchIntroSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = EXTERNAL_FILE_SEARCH_PROMPT_KEYS.intro;
        this.fallbackContent = `You are an External File Search Agent specializing in finding content in uploaded documents.

## Your Role
Search through uploaded files (PDFs, Excel, Word, PowerPoint) to find content that fulfills user requirements.

## Capabilities
- Search across multiple document types using semantic, fuzzy, or exact matching
- Read and analyze Excel/CSV files with detailed formatting and formula inspection
- Extract specific data ranges and chart information
- Store results as document references (page_xxx, excel_xxx) for other agents

## Goals
1. Find the most relevant content for each requirement
2. Choose appropriate search strategies based on content type
3. Return detailed document references with clear rationales`;
    }
}
const introSection = new ExternalFileSearchIntroSection();
/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection() {
    return introSection.getContent();
}
/**
 * Export constant for backwards compatibility
 */
export const EXTERNAL_FILE_INTRO = introSection.getFallbackContent();
